import { Container, Col, Row } from "react-bootstrap";
import Footer from "../../components/Layout/Footer/Footer";
import "../../components/Layout/Jumbotron/JumbotronII";
import "react-toastify/dist/ReactToastify.css";
import ContactForm from "../../components/ContactForm/ContactForm";

const Contact = () => {
  return (
    <div>
      <Container className="JumboBGII" fluid>
        <div className="OverlayII">
          <Row>
            <Col className="text-center">
              <h1>CONTACT US</h1>
            </Col>
          </Row>
        </div>
      </Container>
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Contact;
